import React, {Component} from 'react';
import { makeStyles } from '@material-ui/core/styles';
import {Card, Avatar, CardHeader, Typography, Icon, Link} from '@material-ui/core';
import TagManager from 'react-gtm-module';

const useStyles = makeStyles((theme) => ({
    avatar: {
        backgroundColor: theme.palette.secondary.main,
        color:  theme.palette.text.secundary
    },
    card: {
        paddingTop: 5,
        paddingBottom: 5,
        minHeight: 72,
        cursor: 'auto'
    },
    title1: {
        fontSize:'9pt',
        lineHeight: 1
    },
    link: {
        fontSize:'9pt', 
        fontWeight: 'bold',
        textDecoration: 'underline'
    }
}));

const handlerOnClickEmailSourcing = () => {
    TagManager.dataLayer({
        dataLayer: {
          event: 'event',
          eventCategory: 'tokstok:fornecedores:inicio',
          eventAction: 'clique:botao',
          eventLabel: 'duvidas:clique-aqui',
        }
    });
};

const handlerOnClickEmailHelpDesk = () => {
    TagManager.dataLayer({
        dataLayer: {
          event: 'event',
          eventCategory: 'tokstok:fornecedores:inicio',
          eventAction: 'clique:botao',
          eventLabel: 'problemas-portal:clique-aqui',
        }
    });
};

const ComponentItem = (pai) => {
    const classes = useStyles();

    return (
        <Card>
            
            <CardHeader  
                className={classes.card}    
                title={
                    <div>
                        <Typography className={classes.root} variant="caption">
                            {pai.props.title1}
                            <Link 
                                key="Email" 
                                component="a" 
                                href="mailto:sourcing@tokstok.com.br"
                                className={classes.link}
                                onClick={handlerOnClickEmailSourcing}
                            >
                                clique aqui.
                            </Link>
                        </Typography>
                        <br/>
                        <Typography className={classes.root} variant="caption">
                            {pai.props.title2}
                            <Link 
                                key="Email" 
                                component="a" 
                                href="mailto:helpdesk@tokstok.com.br"
                                className={classes.link}
                                onClick={handlerOnClickEmailHelpDesk}
                            >
                                clique aqui.
                            </Link>
                        </Typography>
                    </div>
                }
                avatar={
                    <Avatar aria-label="recipe" className={classes.avatar}>          
                        <Icon>{pai.props.icone}</Icon> 
                    </Avatar>
                }
            />                
            
        </Card>
    );
};

export default class ItemHelp extends Component {

    constructor(props) {
        super(props);
    };

    render() {
        return (<ComponentItem {...this}/>);
    };

};
